import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './Input.scss';

const textTypes = ['text', 'password', 'email'];
const choiceTypes = ['radio', 'checkbox'];

const Input = ({
    className,
    choices,
    disabled,
    error,
    focus,
    id,
    label,
    name,
    style,
    type,
    value,
    placeholder,
    onKeyDown,
    onChange,
    useValueAttr = false
}) => {
    const isTextInput = textTypes.indexOf(type) >= 0;
    const isChoiceInput = choiceTypes.indexOf(type) >= 0;

    return (
        <div
            className={cn('Form__Element', className, {
                ['input-disabled']: disabled,
                FormTextBox: isTextInput,
                FormChoice: isChoiceInput,
                ValidationFail: error
            })}
            style={style}
        >
            {label && isTextInput &&
                <label className="Form__Element__Caption" htmlFor={id}>
                    {label}
                </label>
            }

            {label && isChoiceInput &&
                <span className="Form__Element__Caption">
                    {label}
                </span>
            }

            {isTextInput &&
                <input
                    {...(useValueAttr ? { value: value } : { defaultValue: value })}
                    disabled={disabled}
                    className={cn('FormTextbox__Input', {
                        ['focus']: focus
                    })}
                    id={id}
                    name={name}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    type={type}
                />
            }

            {isChoiceInput &&
                choices && choices.map(choice => (
                    <label key={choice.value}>
                        <input
                            className={cn('FormChoice__input', {
                                'FormChoice__input--Checkbox': type === 'checkbox',
                                'FormChoice__input--Radio': type === 'radio'
                            })}
                            name={name}
                            type={type}
                            value={choice.value}
                        />
                        {choice.label}
                    </label>
                ))
            }

            {error && (
                <span className="Form__Element__ValidationError">
                    <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <title>Warning</title>
                        <path d="M9.5,19 C4.2619375,19 0,14.7386563 0,9.5 C0,4.2619375 4.2619375,0 9.5,0 C14.7380625,0 19,4.2619375 19,9.5 C19,14.7386563 14.7380625,19 9.5,19 Z M9.5,1.1875 C4.91625,1.1875 1.1875,4.91625 1.1875,9.5 C1.1875,14.0831563 4.91625,17.8125 9.5,17.8125 C14.08375,17.8125 17.8125,14.0831563 17.8125,9.5 C17.8125,4.91625 14.08375,1.1875 9.5,1.1875 Z M9.5,14.84375 C9.345625,14.84375 9.19065625,14.7784375 9.0784375,14.6715625 C8.97096875,14.55875 8.90625,14.404375 8.90625,14.25 C8.90625,14.095625 8.97096875,13.94125 9.0784375,13.8284375 C9.298125,13.60875 9.701875,13.60875 9.9215625,13.8284375 C10.0284375,13.94125 10.09375,14.095625 10.09375,14.25 C10.09375,14.404375 10.0284375,14.55875 9.9215625,14.6715625 C9.80815625,14.7784375 9.654375,14.84375 9.5,14.84375 Z M9.5,12.46875 C9.17165625,12.46875 8.90625,12.2033438 8.90625,11.875 L8.90625,4.75 C8.90625,4.42165625 9.17165625,4.15684375 9.5,4.15684375 C9.82834375,4.15684375 10.09375,4.42165625 10.09375,4.75 L10.09375,11.875 C10.09375,12.2033438 9.82834375,12.46875 9.5,12.46875 Z" id="Shape"></path>
                    </svg>
                    {error}
                </span>
            )}
        </div>
    );
};

Input.propTypes = {
    className: PropTypes.string,
    choices: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ])
    })),
    disabled: PropTypes.bool,
    name: PropTypes.string,
    id: PropTypes.string,
    focus: PropTypes.bool,
    label: PropTypes.string,
    type: PropTypes.oneOf(textTypes.concat(choiceTypes)).isRequired,
    value: PropTypes.string,
    style: PropTypes.object,
    error: PropTypes.string,
    placeholder: PropTypes.string,
    onKeyDown: PropTypes.func,
    onChange: PropTypes.func,
    useValueAttr: PropTypes.bool
};

Input.propTypesMeta = {
    useValueAttr: 'exclude',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/Input.jsx